(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('secAppsStatusDao', ["http", "$q", function (http, $q) {
        return {
            allCounts: function () {
                return http.get('/api/v1/apps/sec_apps_status/all_counts');
            },
            countsBySaas: function (saasApps) {
                return http.post('/api/v1/apps/sec_apps_status/counts_by_saas').body({ saas_apps: saasApps || [] }).run();
            },
            allCountsByType: function (type, periods, saasApps) {
                return http.post('/api/v1/apps/sec_apps_status/all_counts_by_type').body({
                    match_type: type,
                    periods: periods || [],
                    saas_apps: saasApps || []
                }).run();
            },
            license: function () {
                return http.get('/api/v1/apps/sec_apps_status/license');
            },
            queue: function (app, saas) {
                return http.get('/api/v1/apps/sec_apps_status/' + app + '/queue' + (saas && saas !== 'all' ? '/' + saas : ''));
            },
            lastMatch: function (app, saas) {
                return http.get('/api/v1/apps/sec_apps_status/' + app + '/last_match' + (saas && saas !== 'all' ? '/' + saas : ''));
            },
            lastUnmatch: function (app, saas) {
                return http.get('/api/v1/apps/sec_apps_status/' + app + '/last_unmatch' + (saas && saas !== 'all' ? '/' + saas : ''));
            },
            counts: function (app, type, hours, saas) {
                return http.get('/api/v1/apps/sec_apps_status/' + app + '/counts/' + type + '/' + hours + (saas && saas !== 'all' ? '/' + saas : ''));
            },
            processTime: function (app, saas) {
                return http.get('/api/v1/apps/sec_apps_status/' + app + '/process_time/1' + (saas && saas !== 'all' ? '/' + saas : ''));
            },
            vendorTime: function (app, saas) {
                return http.get('/api/v1/apps/sec_apps_status/' + app + '/vendor_time/1' + (saas && saas !== 'all' ? '/' + saas : ''));
            }
        };
    }]);
}());